export default __webpack_public_path__ + "static/media/SEGOEUIL.895c3db8.TTF";